var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPresent = function SvgIconPresent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M12.97 1.791c-.403-.238-.906-.124-1.208.254L9.95 4.711 8.238 2.045c-.302-.378-.805-.492-1.208-.254a.835.835 0 0 0-.302 1.116l1.41 2.073H4.11c-.906 0-1.611.748-1.611 1.67v1.668c0 .618.302 1.157.805 1.446v6.065a2.5 2.5 0 0 0 2.517 2.504h8.356a2.5 2.5 0 0 0 2.517-2.504V9.764c.503-.289.805-.828.805-1.446V6.649c0-.921-.705-1.67-1.61-1.67h-4.028l1.41-2.072a.835.835 0 0 0-.302-1.116M4.11 8.318h5.034V6.649H4.111zm6.746-1.669v1.669h5.033V6.649h-5.033M9.144 9.987H5.017v5.842c0 .461.302.835.805.835h3.322zm1.712 6.677V9.987h4.127v5.842c0 .461-.302.835-.805.835z"
  })));
};
export default SvgIconPresent;